module.exports = __webpack_public_path__ + "static/media/ellipse_gray.a9a1509f.svg";